import { render, staticRenderFns } from "./WbtConfigTable.vue?vue&type=template&id=2a44f5f1&"
import script from "./WbtConfigTable.vue?vue&type=script&lang=js&"
export * from "./WbtConfigTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports